// Bausteine, die beim Variantenwechsel umschalten muessen.
// Alle Varianten sind vorgerendert; sichtbar ist immer nur die gewaehlte.
// Das Theme meldet den Wechsel ueber das Ereignis "variant:update".

class StyaVariantSwitch extends HTMLElement {
  connectedCallback() {
    // Bevorzugt am Produktbereich lauschen; das Ereignis steigt bis zum Dokument auf,
    // deshalb ist document ein verlaesslicher Rueckfallweg.
    this.container = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]') || document;
    this.container.addEventListener('variant:update', this.aktualisieren);
  }

  disconnectedCallback() {
    if (!this.container) return;
    this.container.removeEventListener('variant:update', this.aktualisieren);
  }

  aktualisieren = (event) => {
    const variante = event.detail && event.detail.resource;
    const id = variante && variante.id != null ? String(variante.id) : null;

    let treffer = false;
    this.querySelectorAll('[data-variant-id]').forEach((el) => {
      const passt = id !== null && el.dataset.variantId === id;
      el.hidden = !passt;
      if (passt) treffer = true;
    });

    this.toggleAttribute('data-leer', !treffer);
  };
}

class StyaHinweisComponent extends StyaVariantSwitch {}
class StyaLieferzeitComponent extends StyaVariantSwitch {}

if (!customElements.get('stya-hinweis-component')) {
  customElements.define('stya-hinweis-component', StyaHinweisComponent);
}

if (!customElements.get('stya-lieferzeit-component')) {
  customElements.define('stya-lieferzeit-component', StyaLieferzeitComponent);
}
